import * as $ from 'jquery';

let translations = require('../../root/backend/translations/translations.pl.json');

let resolve = (path: string, obj: any) => {
    return path.split('.').reduce(function(prev, curr) {
        return prev ? prev[curr] : undefined
    }, obj || self)
}

export class TranslateComponent {
    html: string;

    constructor(params) {
        this.html = resolve(Object.keys(params)[0], translations);

        if (!this.html) {
            this.html = Object.keys(params)[0];
        }
    }
}
